import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {ScOres} from '../../../../../../forms/sc-ores';
import {StoreService} from '../../../../../../services/store.service';
import {AuthService} from '../../../../../../services/auth.service';
import {ActivatedRoute} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {NotificationService} from '../../../../../../services/notification.service';
import {ScCargo} from '../../../../../../forms/sc-cargo';
import {FbFormObject} from '../../../../../../class/fb_form_object';
import {AppSettings} from '../../../../../../config/AppSettings';
import {ScRawMaterial} from '../../../../../../forms/sc-raw-material';

@Component({
  selector: 'app-sc-commodity-edit',
  templateUrl: './sc-commodity-edit.component.html',
  styleUrls: ['./sc-commodity-edit.component.css']
})
export class ScCommodityEditComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('select_caption_tpl', {static: true}) set select_caption_tpl(value: ElementRef) {
    this._select_caption_tpl = value;
    this.cdr.markForCheck();
  }

  public loading_text = '';
  public is_loading = true;
  public fields: any[];
  public mode = 'edit';
  public edit = false;
  public rows = [];
  public count = 0;

  private subs: Array<Subscription> = [];
  private record: any;
  private id = '';
  private version_id = 0;
  private Store: FbFormObject;

  private _select_caption_tpl: ElementRef;

  constructor(private storeService: StoreService,
              private authService: AuthService,
              private notificationService: NotificationService,
              private route: ActivatedRoute,
              private cdr: ChangeDetectorRef,
              public dialog: MatDialog) {
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.subs.push(this.route.params.subscribe((params: any) => {
      this.version_id = params.version_id;
      this.edit = this.authService.isAdmin() || this.authService.hasRole(AppSettings.ifa_guild_id, AppSettings.group_page_admin);

      if (params.id && params.id !== 'add') {
        this.mode = 'edit';
        this.id = params.id;
      } else {
        this.mode = 'add';
      }

      switch (params.com_type) {
        case 'ore':
          this.Store = new ScOres(this.storeService, this.authService, this.mode);
          break;
        case 'raw':
          this.Store = new ScRawMaterial(this.storeService, this.authService, this.mode);
          break;
        case 'cargo':
          this.Store = new ScCargo(this.storeService, this.authService, this.mode);
          break;
      }

      const filter = [];
      filter.push('filter[com_id][0][mode]=equals');
      filter.push('filter[com_id][0][operator]=and');
      filter.push('filter[com_id][0][value]=' + this.id);
      filter.push('first=0');
      filter.push('rows=1');

      this.Store.init({select_caption_tpl: this._select_caption_tpl}, {
        version_id: this.version_id
      }, '?' + filter.join('&')).then((success) => {
        this.fields = this.Store.getEditFields();
        if (this.id && this.id !== '' && this.mode === 'edit') {
          const rec = this.Store.getStore().getRecordById(this.id);
          if (rec) {
            this.record = rec;
          }
        } else {
          this.resetModel();
          this.record.data.version_id = Number(this.version_id);
        }
        this.rebuildForm();
        this.is_loading = false;
      });

    }));
  }

  public rebuildForm() {
    this.fields = [];
    this.cdr.detectChanges();
    this.fields = this.Store.getForm(this.record.data);
    this.cdr.detectChanges();
  }

  private resetModel() {
    this.record = this.Store.getDefaultModel();
  }

  public saveStore(event: any) {


    if (this.mode === 'edit') {
      this.Store.getStore().patchRecord(this.record, '').then((res) => {
        if (res && res.success) {
          this.notificationService.success('Data',
              'Speichern erfolgreich.', {timeOut: 5000});
          this.rebuildForm();
        } else {
          this.notificationService.error('Benutzer Ziele',
              'Speichern fehlgeschlagen.', {timeOut: 5000});
        }
      });
    } else {
      this.Store.getStore().addRecord(this.record.data, '').then((res) => {
        if (res && res.success) {
          this.notificationService.success('Data',
              'Speichern erfolgreich.', {timeOut: 5000});
          this.resetModel();
          this.rebuildForm();
        } else {
          this.notificationService.error('Data',
              'Speichern fehlgeschlagen.', {timeOut: 5000});
        }
      });
    }
  }


  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
    if (this.mode === 'edit') {
      this.Store.getStore().revertRecord(this.record);
    }
  }
}
